export default {
  appointment: {
    created: 'Rendez-vous créé avec succès',
    updated: 'Rendez-vous mis à jour',
    cancelled: 'Rendez-vous annulé',
    confirmed: 'Rendez-vous confirmé',
    reminder: 'Rappel : Rendez-vous dans {{time}}',
    create_error: 'Erreur lors de la création du rendez-vous',
    update_error: 'Erreur lors de la mise à jour',
    deleted: 'Rendez-vous supprimé',
    delete_error: 'Erreur lors de la suppression',
    confirm_error: 'Erreur lors de la confirmation',
    cancel_error: "Erreur lors de l'annulation",
    noshow_marked: 'Rendez-vous marqué comme absent',
    noshow_error: 'Erreur lors du marquage'
  },
  teleconsult: {
    started: 'Téléconsultation démarrée',
    ended: 'Téléconsultation terminée',
    urgent: 'Nouvelle téléconsultation urgente !',
    waitingRoom: "Vous êtes en salle d'attente",
    prescription_received: 'Vous avez reçu une nouvelle prescription électronique.',
    about_to_start: '🚀 Votre consultation va commencer !',
    cancelled_toast: '❌ Consultation annulée'
  },
  auth: {
    loginSuccess: 'Bienvenue, {{name}} !',
    loginError: 'Identifiants incorrects',
    logout: 'Déconnexion réussie',
    sessionExpired: 'Session expirée, veuillez vous reconnecter',
    mfaRequired: 'Code MFA requis',
    mfaSuccess: 'Authentification MFA réussie'
  },
  patient: {
    created: 'Patient créé avec succès',
    updated: 'Informations patient mises à jour',
    shortNumberGenerated: 'Numéro court généré : {{number}}',
    create_error: 'Erreur lors de la création du patient',
    updated_success: 'Patient mis à jour',
    update_error: 'Erreur lors de la mise à jour',
    deleted: 'Patient supprimé',
    delete_error: 'Erreur lors de la suppression',
    short_number_error: 'Erreur lors de la génération du numéro court'
  },
  call: {
    incoming: 'Appel entrant de {{caller}}',
    incoming_generic: 'Appel entrant',
    accepted: 'Appel accepté',
    declined: 'Appel refusé',
    calling: 'Appel en cours...',
    connected: 'Appel connecté',
    ended: 'Appel terminé',
    failed: "Échec de l'appel",
    video_connected: 'Connexion vidéo établie',
    video_lost: 'Connexion vidéo perdue',
    camera_changed: 'Caméra changée',
    camera_change_failed: 'Impossible de changer de caméra',
    mic_enabled: 'Microphone activé',
    mic_disabled: 'Microphone désactivé',
    cam_enabled: 'Caméra activée',
    cam_disabled: 'Caméra désactivée',
    reconnecting: 'Reconnexion en cours... ({{current}}/{{max}})',
    connection_lost_restart: "Connexion perdue. Veuillez redémarrer l'appel.",
    webrtc_error: 'Erreur WebRTC: {{error}}',
    media_access_failed: "Impossible d'accéder à la caméra/microphone",
    offer_failed: "Erreur lors de la création de l'offre",
    answer_failed: 'Erreur lors de la création de la réponse',
    remote_desc_failed: 'Erreur lors de la configuration de la description distante'
  },
  network: {
    offline: 'Connexion perdue',
    online: 'Connexion rétablie',
    slowConnection: 'Connexion lente détectée...',
    unavailable: 'Connexion non disponible.',
    unavailable_retry: 'Connexion non disponible. Veuillez patienter.',
    retrying: 'Tentative {{attempt}}/{{max}}... Nouvelle tentative dans {{delay}}s',
    attempt: 'Tentative {{attempt}}/{{max}}',
    nextAttempt: 'Nouvelle tentative dans {{seconds}}s',
    retryNow: 'Réessayer maintenant',
    cancel: 'Annuler',
    statusOffline: 'Hors ligne',
    statusSlow: 'Connexion lente',
    statusGood: 'Connexion correcte',
    statusExcellent: 'Connexion excellente'
  },
  monitoring: {
    memory_critical: 'Utilisation mémoire critique',
    high_latency: 'Latence réseau élevée',
    packet_loss: 'Perte de paquets détectée',
    no_metrics: 'Aucune métrique disponible'
  },
  appointments: {
    loadDoctorsError: 'Erreur lors du chargement des médecins',
    requestSent: 'Demande envoyée au médecin en attente de validation',
    confirmError: 'Impossible de confirmer : {{error}}',
    slotNotOpen: "Ce créneau n'est pas ouvert à la réservation automatique.",
    slotPending: 'Ce créneau a déjà une demande de rendez-vous en attente.',
    slotOccupied: 'Ce créneau est déjà occupé.'
  },
  chat: {
    sendError: "Erreur lors de l'envoi du message",
    emergencyAlertSent: "Alerte d'urgence envoyée",
    emergencyAlertError: "Erreur lors de l'envoi de l'alerte",
    newMessage: 'Nouveau message'
  }
};
